import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import TireSerachDrawer from '../Components/TireSearchDrawer'
import RimSerachDrawer from '../Components/RimSearchDrawer'
import VehicleData from '../Components/VehicleData'
import * as debounce from 'lodash.debounce'
import {
    query,
    submitSearchFacet,
    toggleVisibleDropdownMenu,
    searchFacetChange,
} from '../Actions/FacetedSearch.action'
import { translate } from '../Services/translation'
import {
    PRODUCT_VIEW_CACHED,
    updateFilterOption,
} from '../Actions/FacetedSearch.action'
import {
    getVehicleDataByRegNo,
    getVehicleDataByVariantId,
    removeVehicle,
    clearState,
} from '../Actions/VehicleFinder.action'
import { show as showNotification } from '../Actions/Notification.action'
import VehicleFinder from '../Components/VehicleFinder'
import { isNullOrWhiteSpace } from '../Services/strings'
import LoadingOverlay from '../Components/LoadingOverlay'
import constants from "../constants"

class FacetedSearchCompactContainer extends Component {
    constructor(props) {
        super(props)
        const { facetFilters } = props

        let categoryTemplateId = props.categoryTemplateId

        if(!categoryTemplateId)
            categoryTemplateId = facetFilters.some(x => x.id === constants.filterTags.tireType) ?
                "TireCategory" : "RimCategory"

        this.state = {
            showSearchDrawer: props.drawerOpen,
            regNo: '',
            facetFilters,
            openedFilter: '',
            loading: false,
            categoryTemplateId: categoryTemplateId,
        }
        this.removeVehicle = this.removeVehicle.bind(this)
        this.getVehicleDataByRegNo = this.getVehicleDataByRegNo.bind(this)
        this.handleRegNoInputChange = this.handleRegNoInputChange.bind(this)
        this.handleRegNoInputClick = this.handleRegNoInputClick.bind(this)
        this.getVehicleDataByVehicleSelector = this.getVehicleDataByVehicleSelector.bind(
            this
        )
        this.handleShowSearchDrawer = this.handleShowSearchDrawer.bind(this)
        this.handleCloseSearchDrawer = this.handleCloseSearchDrawer.bind(this)
        this.onFacetChange = this.onFacetChange.bind(this)
        this.getFiltersObject = this.getFiltersObject.bind(this)
        this.getCurrentSearchString = this.getCurrentSearchString.bind(this)
        this.displaySearchBar = this.displaySearchBar.bind(this)
        this.debouncedFacetSubmit = debounce((submit, filters) => submit(filters), 1000)
    }

    onFacetChange(filter, value, submit, callback, isSingleSelect = false) {
        let option = filter.options.find(option => option.id === value)
        if(!filter.singleSelect)
            filter.singleSelect = isSingleSelect
        
        this.setState(
            (prevState, props) => {
                const { facetFilters } = this.state
                const newFilters = updateFilterOption(
                    facetFilters,
                    filter,
                    option
                )
                return {
                    ...prevState,
                    facetFilters: newFilters,
                }
            },
            () => {
                if (submit) {
                    this.debouncedFacetSubmit(this.props.onSubmit, this.state.facetFilters)
                }
                if (callback) {
                    callback()
                }
            }
        )
    }

    onSearchResultDataChange(dom) {
        if ([null, undefined].includes(dom)) {
            return
        }
        const container = document.createElement('div')
        container.innerHTML = dom

        const existingResult = document.querySelector('#search-result')
        const tempResult = container.querySelector('#search-result')

        const existingFilter = existingResult.querySelector('#facetedSearchCompact')
        const tempFilter = tempResult.querySelector('#facetedSearchCompact')

        const existingCompleteWheels = existingResult.querySelector('#completeWheels')
        const tempCompleteWheels = tempResult.querySelector('#completeWheels')

        const replace = (node, newNode) => node.parentNode.replaceChild(newNode, node)

        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter)

        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult)

        // replace complete wheels to avoid re-mounting of container
        if(existingCompleteWheels && tempCompleteWheels)
            replace(tempCompleteWheels, existingCompleteWheels)

        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents(['facetedSearchCompact', 'completeWheels'])
    }

    componentDidUpdate(prevProps) {
        if(prevProps == this.props)
            return
        const productViewCached = window.__litium.cache
            ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {}
            : {}
        if (!productViewCached.used) {
            productViewCached.used = true
            const dom = productViewCached.productsView
            dom && this.onSearchResultDataChange(dom)
        }

        this.setState((previousState) => ({
            ...previousState,
            facetFilters: this.props.facetFilters
        }))

        if(this.props.category) {
            this.setState((previousState) => ({
                ...previousState,
                categoryTemplateId: this.props.category,
            }))
        }
    }

    removeVehicle() {
        this.props.removeVehicle()
        this.setState((previousState) => ({
            ...previousState,
            regNo: '',
        }))
    }

    getVehicleDataByRegNo() {
        if (
            !isNullOrWhiteSpace(this.state.regNo) &&
            this.state.regNo.length === 6
        ) {
            this.setState((previousState) => ({
                ...previousState,
                loading: true,
            }))
            this.props.getVehicleDataByRegNo(
                this.state.regNo,
                (vehicleData) => {
                    this.setState((previousState) => ({
                        ...previousState,
                        loading: false,
                    }))
                    if (vehicleData) {
                        if (this.state.categoryTemplateId === 'TireCategory') {

                            if(this.props.tireCategoryLink) {
                                window.location.href = this.props.tireCategoryLink + vehicleData.tireQueryFilters
                            } else {
                                window.location.href = window.location.pathname
                            }

                        } else if (
                            this.state.categoryTemplateId === 'RimCategory'
                        ) {
                            if(this.props.rimCategoryLink) {
                                window.location.href =
                                this.props.rimCategoryLink +
                                vehicleData.rimQueryFilters
                            } else {
                                window.location.href = window.location.pathname

                            }
                        }
                    }
                }
            )
        }
    }

    getVehicleDataByVehicleSelector(selectedVariant) {
        this.setState((previousState) => ({
            ...previousState,
            loading: true,
        }))

        this.props.getVehicleDataByVariantId(selectedVariant, (vehicleData) => {
            this.setState((previousState) => ({
                ...previousState,
                loading: false,
            }))
            if (vehicleData) {
                if (this.state.categoryTemplateId === 'TireCategory') {

                    if(this.props.tireCategoryLink) {
                        window.location.href = this.props.tireCategoryLink + vehicleData.tireQueryFilters
                    } else {
                        window.location.href = window.location.pathname
                    }

                } else if (
                    this.state.categoryTemplateId === 'RimCategory'
                ) {
                    if(this.props.rimCategoryLink) {
                        window.location.href =
                        this.props.rimCategoryLink +
                        vehicleData.rimQueryFilters
                    } else {
                        window.location.href = window.location.pathname
                    }
                }
            }
        })
    }

    handleRegNoInputChange(regNo) {
        this.setState((previousState) => ({
            ...previousState,
            regNo: regNo,
        }))
    }

    handleRegNoInputClick() {
        this.props.clearState()
    }

    handleShowSearchDrawer() {
        this.setState({showSearchDrawer: true})
    }

    handleCloseSearchDrawer() {
        this.setState({showSearchDrawer: false})
    }

    getCurrentSearchString() {
        const filters = this.getFiltersObject()
        if(this.state.categoryTemplateId === "TireCategory") {
            const selectedWidth = filters[constants.filterTags.widthInMm]?.selectedOptions[0]
            const selectedHeight = filters[constants.filterTags.height]?.selectedOptions[0]
            const selectedDiameter = filters[constants.filterTags.diameter]?.selectedOptions[0]
            const selectedTyreType = filters[constants.filterTags.winterTireType]?.selectedOptions[0] ?? filters[[constants.filterTags.tireType]]?.selectedOptions[0]
            if(!selectedWidth || !selectedHeight || !selectedDiameter)
                return "Ingen storlek vald"

            return `${selectedWidth}/${selectedHeight}R${selectedDiameter} ${selectedTyreType?.toUpperCase() ?? ""}`
        }

        if(this.state.categoryTemplateId === "RimCategory") {
            return `${filters[constants.filterTags.diameter]?.selectedOptions[0]}"`
        }
    }

    getFiltersObject() {
        var filters = {}
        this.state.facetFilters?.forEach(filter => {
            filters[filter.id] = filter
        })

        return filters;
    }

    displaySearchBar() {
        if(!this.state.facetFilters)
            return false

        if(this.state.categoryTemplateId === 'TireCategory')
            return true
        
        return !!this.props?.vehicleFinder?.vehicleData
    }

    render() {
        const { facetFilters } = this.state
        const {
            subNavigation = [],
            sortCriteria = [],
        } = this.props
        const filters = this.getFiltersObject()

        const { vehicleFinder } = this.props
        var { vehicleData } = vehicleFinder

        const hidden = [subNavigation, facetFilters, sortCriteria].every(
            (ele) => !ele || ele.length === 0
        )

        // Filter out tire sizes that don't match the selected rim
        // Used for complete wheels
        if(this.props.category && vehicleData?.selectedProducts?.rimCategory) {
            const selectedRimSize = vehicleData.selectedProducts.rimCategory.diameter
            vehicleData.tires = vehicleData?.tires.filter(x => x.diameter == selectedRimSize && x.isFront)
        }

        return (
            <Fragment>
                <LoadingOverlay loading={this.props.loading} />

                <div style={{marginTop: "10px"}} className="">
                    <div className="vehiclefinder-block">
                        {!vehicleData ? (
                            <div className="vehicle-finder">
                                <VehicleFinder
                                        vehicleData={vehicleData}
                                        errors={
                                            vehicleFinder.errors
                                        }
                                        handleRegNoInputChange={
                                            this
                                                .handleRegNoInputChange
                                        }
                                        getVehicleDataByRegNo={
                                            this
                                                .getVehicleDataByRegNo
                                        }
                                        handleRegNoInputClick={
                                            this
                                                .handleRegNoInputClick
                                        }
                                        regNo={this.state.regNo}
                                        getVehicleDataByVehicleSelector={
                                            this
                                                .getVehicleDataByVehicleSelector
                                        }
                                        loading={this.props.loading}
                                    />
                            </div>
                        ) : (
                            <VehicleData
                                vehicleData={vehicleData}
                                removeVehicle={this.props.removeVehicle}
                            />
                        )}
                    </div>
                    {this.displaySearchBar() && !hidden && 
                        <div className="current-search-container">
                            <p>{translate("facet.header.search")} <br /> 
                            <b>{this.getCurrentSearchString()}</b></p>
                            <button onClick={this.handleShowSearchDrawer} className="button buy-button product__buy-button">
                                {translate("facet.changesearch.button")}
                            </button>
                        </div>
                    }
                </div>
                {this.displaySearchBar() && !hidden && <>
                    {this.state.categoryTemplateId === 'TireCategory' && (
                        <TireSerachDrawer  
                            filters={filters}
                            onFacetChange={this.onFacetChange}
                            showDrawer={this.state.showSearchDrawer}
                            drawerRef={this.drawerRef} 
                            handleCloseSearchDrawer={this.handleCloseSearchDrawer}
                            totalHits={this.props.totalHits}
                            vehicleData={vehicleData}
                        />
                    )}
                    {this.state.categoryTemplateId === 'RimCategory' && (
                        <RimSerachDrawer  
                            filters={filters}
                            onFacetChange={this.onFacetChange}
                            showDrawer={this.state.showSearchDrawer}
                            drawerRef={this.drawerRef} 
                            handleCloseSearchDrawer={this.handleCloseSearchDrawer}
                            totalHits={this.props.totalHits}
                            vehicleData={vehicleData}
                        />
                    )}
                </>}
            </Fragment>
        )
    }
}

const mapStateToProps = ({
    facetedSearch: {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
        loading,
        drawerOpen,
        totalHits
    },
    completeWheels: {
        category
    },
    vehicleFinder,
}) => {
    return {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
        vehicleFinder,
        category,
        loading,
        drawerOpen,
        totalHits
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        query: (q, withHtmlResult) => dispatch(query(q, withHtmlResult)),
        onSubmit: (allFilters) => dispatch(submitSearchFacet(allFilters)),
        toggleVisibleDropdownMenu: (group) =>
            dispatch(toggleVisibleDropdownMenu(group)),
        searchFacetChange: (group, item) =>
            dispatch(searchFacetChange(group, item)),
        removeVehicle: () => dispatch(removeVehicle()),
        getVehicleDataByRegNo: (regNo, callback) =>
            dispatch(getVehicleDataByRegNo(regNo, callback)),
        getVehicleDataByVariantId: (vehicleVariantId, callback) =>
            dispatch(getVehicleDataByVariantId(vehicleVariantId, callback)),
        clearState: () => dispatch(clearState()),
        showNotification: (nodeIdToShowNotification, notificationMessage) => dispatch(showNotification(nodeIdToShowNotification, notificationMessage))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FacetedSearchCompactContainer)
